import { useEffect } from "react"

export default function ErrorComponent(props) {
    useEffect(() => {
        window.history.back();
    }, [])
    return (<div></div>)
}